import * as r from 'ramda';
import { put, call, select, takeLatest, takeLeading } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const DatasetsToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const refetchDatasets = function* () {
  const queryParams = new URLSearchParams(window.location.search);
  const pageSize = queryParams.get('pageSize') || 20;
  const pageNumber = 1;

  yield put(actions.fetchDatasets(pageSize, pageNumber));
};

const updateDataset = function* ({ payload }) {
  const { id, data } = payload;

  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const dataset = yield select(selectors.getDatasetByIdRaw(id));

  const { key, ...restData } = data;
  dataset.Key = key;
  dataset.Data = {
    ...dataset.Data,
    ...restData,
  };

  try {
    yield put($ui.setUi(UI.Datasets.IsUpdating, id));

    yield call(api.updateDataset, id, dataset, {
      token,
      publisherId,
    });

    yield put($ui.setFalse(UI.Datasets.UpdateDialogVisible)());

    yield call(refetchDatasets);
  } catch (error) {
    DatasetsToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while processing the request',
    });
  } finally {
    yield put($ui.setFalse(UI.Datasets.IsUpdating)());
  }
};

const removeOrderFromDataset = function* ({ payload }) {
  const { datasetId, orderId } = payload;

  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const dataset = yield select(selectors.getDatasetByIdRaw(datasetId));

  dataset.TimesUsed -= 1;
  dataset.OrderIds = r.without(orderId, dataset.OrderIds);

  try {
    yield put($ui.setUi(UI.Datasets.IsUpdating, datasetId));

    yield call(api.updateDataset, datasetId, dataset, {
      token,
      publisherId,
    });

    yield call(api.removeOrder, orderId, {
      token,
      publisherId,
    });

    yield call(refetchDatasets);
  } catch (error) {
    DatasetsToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while processing the request',
    });
  } finally {
    yield put($ui.setFalse(UI.Datasets.IsUpdating)());
  }
};

export const updateDatasetSaga = function* () {
  yield takeLeading(actions.updateDataset, updateDataset);
  yield takeLatest(actions.removeOrderFromDataset, removeOrderFromDataset);
};
